import './styles.scss';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {IStore} from '../../redux/interface';
import {Link, useParams} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {useGetTranslations} from '../../utils/hooks/useGetTranslations';
import {TranslationKeys} from '../../utils/constants/routeConstants';
import {
  articleAsyncActions, getTeiArticle, getTeiArticleSection
} from '../../redux/pageAsyncActions';
import './styles.scss';
import {closeArticleSection} from '../../redux/article/actions';
import Loader from '../../components/loader';
import Section from '../../components/section';

export const ArticleSection: React.FunctionComponent = () => {
  const {
    article,
    section
  } = useSelector((state: IStore) => state.article);
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const dispatch = useDispatch();
  const {articleId, sectionIndex} = useParams();

  useGetTranslations({
    translationKey: TranslationKeys.Article
  });

  useEffect(() => {
    dispatch(closeArticleSection());
    if (articleId && sectionIndex) {
      if (!article || article.id.toString() !== articleId) {
        dispatch(articleAsyncActions[getTeiArticle](articleId));
      }
      dispatch(articleAsyncActions[getTeiArticleSection](articleId, sectionIndex));
    }
  }, [articleId]);

  return <div className="section-page">
    {!section && loading.includes(getTeiArticleSection) && <Loader className="section-page-loader"/>}
    <header className="section-page__header">
      <h1><FormattedMessage
        id={'gritx.article.section'}
        defaultMessage={'Section'}
      /></h1>
      {article && <Link to={`/article/${article.id}`} className="section-page__link">
        <FormattedMessage
          id={'gritx.article.backToArticle'}
          defaultMessage={'Back to article'}
        /></Link>}
      {article && <Link to={`/article/tableofcontents/${article.id}`} className="section-page__link">
        <FormattedMessage
          id={'gritx.article.backToTableOfContents'}
          defaultMessage={'Back to Table Of Contents'}
        /></Link>}
    </header>
    <main className="section-page__container">
      {section && <div className="section-page__body">
        <Section section={section}/>
      </div>}
    </main>
  </div>;
};
